import { gql, useLazyQuery } from "@apollo/client";

const LIST_LINKSERVICE_NEAR_QUERY = gql`
  query listLinkServiceNear($input: ListLinkServiceNearInput!) {
    listLinkServiceNear(input: $input) {
      ok
      err
      linkservice {
        id
        name
        description
        latitude
        longitude
        address
        distance
        isActive
      }
    }
  }
`;

export interface ListLinkServiceNearQuery {
  listLinkServiceNear: {
    linkservice: {
      id: string;
      name: string;
      description: string;
      latitude: number;
      longitude: number;
      address: string;
      distance: number;
      isActive: boolean;
    }[];
  };
}

export interface ListLinkServiceNearInput {
  latitude: number;
  longitude: number;
}

export const useListLinkServiceNear = (
  onCompleted?: (data: ListLinkServiceNearQuery) => void
) => {
  return useLazyQuery<ListLinkServiceNearQuery>(LIST_LINKSERVICE_NEAR_QUERY, {
    onCompleted,
  });
};
